import React from "react";
import Grid from "@mui/material/Grid";
import { translate, translateHelperTextIfExists } from "../../../../services/translations/translations";
import FormLegend from "../../Common/FormLegend/FormLegend";
import { ValidatorType } from "../../../../types/ValidatorType";
import { requiredValidator } from "../../../../services/validationRules";
import wizardStyle from "../../wizardStyle";
import ValidatorDateField from "../../../FormFields/ValidatorDateField";

type YearFieldConfiguredProps = {
  caseData: Record<string, any>;
  fieldPath: string;
  required?: boolean;
};

export default function YearFieldConfigured({ caseData, fieldPath, required = false }: YearFieldConfiguredProps) {
  const helperText = translateHelperTextIfExists(caseData, fieldPath);
  const question = translate(`${caseData.name}.${fieldPath}.question`, caseData, "");
  const label = translate(`${caseData.name}.${fieldPath}.label`, caseData);
  const validators: ValidatorType[] = [];

  if (required) {
    validators.push(requiredValidator());
  }

  return (
    <>
      {question && (
        <Grid sx={wizardStyle.gridTopSpaced} size={12}>
          <FormLegend>{question}</FormLegend>
        </Grid>
      )}
      <Grid size={12}>
        <ValidatorDateField
          name={fieldPath}
          label={label}
          helperText={helperText}
          validators={validators}
          views={["year"]}
          openTo="year"
        />
      </Grid>
    </>
  );
}
